import React, { useContext } from 'react';
import { Col, Row } from '@firsttable/web-components/atoms';
import { ContainerContent, RowHead } from '@firsttable/web-components/molecules';
import DynamicUserForm from '../organisms/Forms/DynamicUserForm';
import parseHtml from '../../lib/parseHtml';
import SilverstripeContext from '../context/Silverstripe';
import SEO from '../SEO';

const UserDefinedForm = () => {
  const { page } = useContext(SilverstripeContext);
  return (
    <>
      <SEO
        title={page.metaTitleFormatted}
        id={page.id}
        description={page.metaDescription}
        ogImage={page.ogImage}
        metaTags={page.metaTags}
        slug={page.slug}
      />
      <ContainerContent>
        <RowHead title={page.title} subTitle={page.subTitle} mb={0} />
        <Row gap={164} display="flex" justifyContent="center">
          <Col width={[1, 3 / 4, 2 / 3]} mt={20}>
            <DynamicUserForm
              id="ContactForm"
              formData={page.userForm}
              formFields={page.userForm.formFields}
              formContent={parseHtml(page.content)}
            />
          </Col>
          {page.sidebarContent !== '' && (
            <Col width={[1, 3 / 4, 2 / 3]} mt={20}>
              {parseHtml(page.sidebarContent)}
            </Col>
          )}
        </Row>
      </ContainerContent>
    </>
  );
};

export default UserDefinedForm;
